export class CompanyFiscalYearRes {
    id!: number;
    companyId!: number;
    year!: number;
    timeTrackingClosed!: boolean;
    accountingClosed!: boolean;
    createdAtUtc!: any;
    updatedAtUtc?: any;
}

export class CompanyFiscalYearCreateReq {
    year!: number;
    timeTrackingClosed: boolean = false;
    accountingClosed: boolean = false;
}

export class CompanyFiscalYearUpdateReq {
    timeTrackingClosed: boolean = false;
    accountingClosed: boolean = false;
}
